import { NAV_HUBS, TOOL_NAV_ITEMS } from '@/pages/ipe/workbench/constants/workbenchNavConfig';

const HUB_NAV_IDS = Object.keys(NAV_HUBS);

/** 教程可关联的工作台模块（全部工具 + Hub） */
const LINKABLE_NAV_IDS = [
  ...HUB_NAV_IDS,
  ...Object.keys(TOOL_NAV_ITEMS),
];

export const TUTORIAL_LINKABLE_NAV_OPTIONS = [...new Set(LINKABLE_NAV_IDS)]
  .map((id) => {
    const label = TOOL_NAV_ITEMS[id]?.label || NAV_HUBS[id]?.label;
    if (!label) return null;
    return { value: id, label };
  })
  .filter(Boolean)
  .sort((a, b) => a.label.localeCompare(b.label, 'zh-CN'));

export function tutorialNavLabel(navId) {
  if (!navId) return '';
  return TOOL_NAV_ITEMS[navId]?.label || NAV_HUBS[navId]?.label || navId;
}
